import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { cardContentStyles } from './styles/card-content.styles';
import type { CardContentPropsInterface } from './types/card-content.types';

/**
 * @since 10.0.0
 */
export const CardContent = forwardRef<HTMLDivElement, CardContentPropsInterface>(
  (props: CardContentPropsInterface, forwardedRef) => {
    const { className, css: cssProp, ...rest } = props;
    const styles = css(cardContentStyles, cssProp);
    return (
      <div
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Card.Content"
        className={cx('c11n', styles, className)}
        {...rest}
      />
    );
  },
);

CardContent.displayName = 'Card.Content';
